import { RootState } from '../index';
import { StoreStatus } from '../../core/types/common.types';
import { StagedShipmentMeta } from '../../core/api/lab.types';

export const hasErrorSelector = (state: RootState): boolean =>
  state.stagedShipmentMeta.errors && state.stagedShipmentMeta.errors ? true : false;

export const getStagedShipmentMetaIsBusySelector = (state: RootState): boolean =>
  state.stagedShipmentMeta.status === StoreStatus.BUSY;

export const getStagedShipmentMetaResponseSelector = (state: RootState): StagedShipmentMeta | null =>
  state.stagedShipmentMeta.response || null;
